import { NgClass } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { IconComponent } from "../../../shared/components/icon/icon.component";
import { ISnackbarData } from '../../models/notification';

@Component({
  selector: 'app-snackbar',
  standalone: true,
  imports: [NgClass, IconComponent],
  templateUrl: './snackbar.component.html',
  styleUrl: './snackbar.component.scss'
})
export class SnackbarComponent {
  constructor(
    public snackBarRef: MatSnackBarRef<SnackbarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: ISnackbarData
  ) { }

  onClose(clickEvent: MouseEvent): void {
    clickEvent.stopPropagation();
    this.snackBarRef.dismiss();
  }
}
